import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/article/KakobuySpreadsheetGuide/page";
import SpreadsheetComparison from "../pages/article/SpreadsheetComparison/page";
import SafetyGuide from "../pages/article/SafetyGuide/page";
import BestFinds2026 from "../pages/article/BestFinds2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-kompletny-przewodnik",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/artykul/kakobuy-vs-cssbuy-vs-superbuy-porownanie",
    element: <SpreadsheetComparison />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-bezpieczenstwo-zakupow",
    element: <SafetyGuide />,
  },
  {
    path: "/artykul/najlepsze-znaleziska-kakobuy-spreadsheet-2026",
    element: <BestFinds2026 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;